import React from 'react'
import { TransparentIconLabelButton } from 'components/generic/buttons/IconLabelButton'

const getButtonCell = (cellData, text, startIcon, onClick) => (
  <TransparentIconLabelButton startIcon={startIcon} text={text} onClick={() => onClick(cellData)} />
)

export default getButtonCell
